
<div *ngIf="show">
	<iframe style="border-radius: 5px;" width="100%" height="300" [src]='tokens' frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
<mat-card *ngIf="!show" fxLayoutAlign="center center" style="min-height: 300px;">
  <span class="material-icons icon-large">movie</span>
</mat-card>
		